import React from 'react';

import withErrorBoundary from 'common/components/withErrorBoundary';
import { UnexpectedError } from 'src/core/common/components/UnexpectedError/UnexpectedError';

import { useGetIntegrations } from '../../../hooks';
import { useGetPartnerIntegrations } from '../../../hooks/useGetPartnerIntegrations';
import { IntegrationsList, IntegrationsListSkeleton } from '../../components';

const IntegrationsListContainer = () => {
  const integrationsQuery = useGetIntegrations();
  const partnerIntegrations = useGetPartnerIntegrations();

  if (integrationsQuery.status === 'loading') {
    return <IntegrationsListSkeleton />;
  }
  if (integrationsQuery.status === 'error') {
    return <UnexpectedError />;
  }
  return (
    <IntegrationsList
      integrationStatus={integrationsQuery.data}
      partnerIntegrations={partnerIntegrations}
    />
  );
};

export default withErrorBoundary({
  scope: 'integrations-list-container',
  team: 'api-integration',
})(IntegrationsListContainer);
